// import { IReduxState } from '../app/types';

export * from './function.any';

/**
 * Returns the visibility state of the gifs menu.
 *
 * @param {Object} state - The state of the application.
 * @returns {boolean}
 */
export function isGifsMenuOpen(state: Object) {
    return state['features/gifs']?.menuOpen;
}
